import styled from '@emotion/styled';
import { StyledProps as Props, Theme } from './Modal.types';
import css from '@styled-system/css';

export const ModalBackground = styled.div<Props, Theme>`
  ${css({
    height: '100%',
    width: '100%',
    backgroundColor: 'var(--color-modal-bg)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    zIndex: 1000,
  })}
`;

export const ModalWrapper = styled.div<Props, Theme>`
  ${css({
    height: '446px',
    width: '443px',
    bg: 'var(--color-extra-white)',
    borderRadius: '4px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  })}
`;
